module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid bg-dark"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-6 offset-md-3 offset-sm-0"
  }, [_c('div', {
    staticClass: "text-center pt-3"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_c('img', {
    attrs: {
      "id": "logo",
      "src": "/static/img/logo.png"
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-3 py-4 text-right"
  }, [_c('user-menu', {
    staticClass: "hidden-xs-down"
  })], 1), _vm._v(" "), _c('flash-messages-list')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66c1867f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/includes/MainHeader.vue
// module id = 1321
// module chunks = 1